import React from "react";
import '../Styles/FamilyCampTierSelection.scss';
import { RoomTier, getBasePrice, getLadderPrice, DELUXE_MAX_CAMPERS } from "../Constants/FamilyCampConfig";
import { FamilyCampPageOptions } from "../Constants/RegistrationPageOptions";

// The jumping-off point for the rest of the wizard — which tier is chosen here decides the whole
// pricing ladder the Add Family Member step prices against. Laid out the same way
// GroupReservationTypeSelection presents Standard vs. Fast Track: two cards, one click commits.
function FamilyCampTierSelection({ week, setRoomType, selectedPage, setSelectedPage,
   nextPage = FamilyCampPageOptions.PersonalInfo, previousPage = FamilyCampPageOptions.WeekSelection }) {

   // Every row of the full price breakdown for this tier, in order, with how much each additional
   // family member saves against the first camper's price — the discount is the point, so it's
   // computed here rather than left for the registrant to work out themselves.
   function breakdownRows(tier) {
      const basePrice = getBasePrice(week, tier)
      const rows = [{ label: 'Camper 1', price: basePrice, savings: 0 }]
      for (let position = 2; position <= DELUXE_MAX_CAMPERS; position++) {
         const price = getLadderPrice(tier, position)
         rows.push({ label: `Camper ${position}`, price, savings: basePrice - price })
      }
      if (tier === RoomTier.Standard) {
         const price = getLadderPrice(tier, DELUXE_MAX_CAMPERS + 1)
         rows.push({ label: 'Each additional camper', price, savings: basePrice - price })
      }
      return rows
   }

   function chooseTier(tier) {
      setRoomType(tier)
      setSelectedPage(nextPage)
   }

   return (
      <div className="familyCampTierSelectionContainer">
         <div className="familyCampTierSelectionContent">
            <div className="familyCampTierSelectionHeading">
               Choose Your Room Type
            </div>
            <div className="familyCampTierSelectionSubHeading">
               Every price below covers the whole family — each additional family member you add
               on the next step shows its own price.
            </div>

            <div className="familyCampTierGrid">
               <div className="familyCampTierCard">
                  <div className="familyCampTierName">
                     Standard Room
                  </div>
                  <div className="familyCampTierTagline">
                     A standard room for the week, with no limit on family size.
                  </div>
                  <div className="familyCampTierDivider"></div>
                  <div className="familyCampTierBreakdown">
                     {breakdownRows(RoomTier.Standard).map((row, index) => (
                        <div className="familyCampTierBreakdownRow" key={index}>
                           <span className="familyCampTierBreakdownLabel">{row.label}</span>
                           <span className="familyCampTierBreakdownPriceGroup">
                              {row.savings > 0 && (
                                 <span className="familyCampTierBreakdownSavings">
                                    Save ${row.savings.toFixed(2)}
                                 </span>
                              )}
                              <span className="familyCampTierBreakdownPrice">${row.price.toFixed(2)}</span>
                           </span>
                        </div>
                     ))}
                  </div>
                  <div className="familyCampTierAction">
                     <button
                        className="familyCampTierButtonPrimary"
                        onClick={() => chooseTier(RoomTier.Standard)}>
                        Choose Standard
                     </button>
                  </div>
               </div>

               <div className="familyCampTierCard">
                  <div className="familyCampTierName">
                     Deluxe Room
                  </div>
                  <div className="familyCampTierTagline">
                     Upgraded lodging for the week, limited to families of 5 or fewer.
                  </div>
                  <div className="familyCampTierDivider"></div>
                  <div className="familyCampTierBreakdown">
                     {breakdownRows(RoomTier.Deluxe).map((row, index) => (
                        <div className="familyCampTierBreakdownRow" key={index}>
                           <span className="familyCampTierBreakdownLabel">{row.label}</span>
                           <span className="familyCampTierBreakdownPriceGroup">
                              {row.savings > 0 && (
                                 <span className="familyCampTierBreakdownSavings">
                                    Save ${row.savings.toFixed(2)}
                                 </span>
                              )}
                              <span className="familyCampTierBreakdownPrice">${row.price.toFixed(2)}</span>
                           </span>
                        </div>
                     ))}
                  </div>
                  <div className="familyCampTierAction">
                     <button
                        className="familyCampTierButtonPrimary"
                        onClick={() => chooseTier(RoomTier.Deluxe)}>
                        Choose Deluxe
                     </button>
                  </div>
               </div>
            </div>

            <div className="familyCampTierSelectionButtonsContainer">
               <div className="familyCampTierSelectionPreviousButton">
                  <button onClick={() => setSelectedPage(previousPage)}>
                     Previous
                  </button>
               </div>
            </div>
         </div>
      </div>
   )
}

export default FamilyCampTierSelection;
